import React, { useEffect, useState } from "react";
import { StyleSheet, css } from "aphrodite";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Dashboard from "../../../services/api/dashboard";

const styles = StyleSheet.create({
  card: {
    background: "#fff",
    borderRadius: 16,
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    marginTop: 16,
    width: "100%",
    overflow: "hidden",
    transition: "all 0.3s ease",
    ":hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "16px 20px 12px 20px",
    borderBottom: "1px solid #f0f0f0",
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    color: "#1a1a1a",
    margin: 0,
  },
  tableContainer: {
    width: "100%",
    overflowX: "auto",
    backgroundColor: "#f8f9fa",
  },
  table: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "0px",
    backgroundColor: "#ffffff",
  },
  headerRow: {
    background: "#1a237e",
  },
  headerCell: {
    padding: "8px 12px",
    fontSize: 13,
    fontWeight: 600,
    color: "#fff",
    textAlign: "left",
    border: "1px solid #dde1e7",
    borderBottom: "1px solid #303f9f",
    ":first-child": {
      paddingLeft: 16,
    },
    ":last-child": {
      paddingRight: 16,
      textAlign: "center", // Center align for Total column
    },
  },
  dataRow: {
    backgroundColor: "#ffffff",
    ":hover": {
      backgroundColor: "#f1f3f7",
    },
    ":nth-child(even)": {
      backgroundColor: "#f9fafb",
    },
  },
  cell: {
    padding: "8px 12px",
    fontSize: 13,
    color: "#333",
    border: "1px solid #e5e7eb",
    borderTop: "none",
    ":first-child": {
      paddingLeft: 16,
      fontWeight: 500,
      color: "#555",
      textAlign: "left",
    },
    ":last-child": {
      paddingRight: 16,
      textAlign: "center", // Center align for Total column
      fontWeight: 500,
    },
  },
  totalRow: {
    backgroundColor: "#f3f4f6",
    fontWeight: 600,
    borderTop: "2px solid #d1d5db",
    ":hover": {
      backgroundColor: "#e5e7eb",
    },
  },
});

function MembershipSummary() {
  const [leadershipData, setLeadershipData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await Dashboard.getMembershipStatistics();
        const data = response?.data?.leadershipChildren || [];
        setLeadershipData(data);
      } catch (err) {
        // setError(err.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  const totalCount = leadershipData.reduce(
    (acc, item) => acc + (item.leaderCount || 0),
    0
  );
  return (
    <div className={css(styles.card)}>
      <div className={css(styles.header)}>
        <h3 className={css(styles.title)}>Membership </h3>
        {/* <InfoOutlinedIcon fontSize="small" style={{ color: "#999" }} /> */}
      </div>

      <div className={css(styles.tableContainer)}>
        <table className={css(styles.table)}>
          <thead>
            <tr className={css(styles.headerRow)}>
              <th className={css(styles.headerCell)}>Unit Name</th>
              <th className={css(styles.headerCell)}>Total</th>
            </tr>
          </thead>
          <tbody>
            {leadershipData
              .slice() // create a copy to avoid mutating state
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((row) => (
                <tr key={row.name} className={css(styles.dataRow)}>
                  <td className={css(styles.cell)}>{row.name}</td>
                  <td className={css(styles.cell)}>{row.leaderCount}</td>
                </tr>
              ))}

            {/* Total Row */}
            <tr className={css(styles.dataRow, styles.totalRow)}>
              <td className={css(styles.cell)}>TOTAL</td>
              <td className={css(styles.cell)}>{totalCount}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MembershipSummary;
